import { render, staticRenderFns } from "./RegisterTienda.vue?vue&type=template&id=4a75b94e"
import script from "./RegisterTienda.vue?vue&type=script&lang=js"
export * from "./RegisterTienda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports